import { EastOutlined } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React from "react";
import ImageInputSourceSelection from "./ImageInputSourceSelection";

interface ImageSelectionModalProps {
  handleClose: () => void;
  setImageSelected: (image: File | string | null) => void;
}

const ImagSelectionModal = ({
  handleClose,
  setImageSelected,
}: ImageSelectionModalProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: {xs:"95%",md:"70%"},
        height: {xs:"70%",md:"95%"},
        overflow: "hidden",
      }}
    >
      {/* header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px 16px",
          backgroundColor: "var(--header_backgroud2)",
          borderRadius: "12px 12px 0px 0px",
          border: "1px solid rgba(118, 207, 235, 0.20)",
        }}
      >
        <Typography
          sx={{
            color: "var(--font_color1)",
            fontFamily: "Inter",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 500,
          }}
        >
          Choose image input
        </Typography>
        <Box
          onClick={handleClose}
          sx={{
            cursor: "pointer",
          }}
        >
          <EastOutlined />
        </Box>
      </Box>
      {/* images selection */}
      <ImageInputSourceSelection setImageSelected={setImageSelected} handleClose={handleClose} />
    </Box>
  );
};

export default ImagSelectionModal;
